import { Form, FormItemProps } from 'antd';
import React, { ReactElement, ReactNode } from 'react';
import Exclamation from './Exclamation';

export default function FormItem(props: FormItemProps): ReactElement {
    const { children, help } = props;

    return (
        <Form.Item
            {...props}
            help={help ? <><Exclamation />{help}</> : null}
        >
            {/* This Div is to stop antd form item from overwriting the value  */}
            <div>
                {children as ReactNode}
            </div>
        </Form.Item>
    );
}